<script>
	export let callback;
	export let paginaAnterior;
	export let paginaAtual;
	export let proximaPagina;
	export let ultimaPagina;
	export let totalResultados;
	export let resultadosPorPagina;
	export let margemInferior = true;

	const executarCallback = parametro => {
		callback(parametro);
	};
</script>

<style>
	.flex-center-fix {
		justify-content: center;
	}
</style>

<div class="{margemInferior == true ? 'columns is-centered is-multiline mb-6' : 'columns is-centered is-multiline'}">
	<div class="column is-12">
		<div class="columns is-centered">
			<div class="field has-addons flex-center-fix">
				<p class="control">
					<button 
						on:click|preventDefault={executarCallback(ultimaPagina / ultimaPagina)} 
						class="button is-primary is-outlined is-fullwidth"
						disabled="{paginaAtual == 1 ? true : false}">
						Pimeiro
					</button>
				</p>
				<p class="control">
					<button 
						on:click|preventDefault={executarCallback(paginaAnterior)} 
						class="button is-primary is-fullwidth"
						disabled="{(paginaAnterior > 0 && paginaAnterior < paginaAtual) ? false : true}">
						Anterior
					</button>
				</p>
				<p class="control is-hidden-mobile">
					<span class="button is-default is-fullwidth">
						Pg. {paginaAtual} de {ultimaPagina}
					</span>
				</p>
				<p class="control">
					<button 
						on:click|preventDefault={executarCallback(proximaPagina)} 
						class="button is-primary is-fullwidth"
						disabled="{(proximaPagina > paginaAtual && proximaPagina <= ultimaPagina) ? false : true}">
						Próximo
					</button>
				</p>
				<p class="control">
					<button 
						on:click|preventDefault={executarCallback(ultimaPagina)} 
						class="button is-primary is-outlined is-fullwidth"
						disabled="{paginaAtual == ultimaPagina ? true : false}">
						Último
					</button>
				</p>
			</div>
		</div>
	</div>
	<div class="column">
		<p class="has-text-primary has-text-centered is-size-7">Total de registros: {totalResultados} - exibindo até {resultadosPorPagina} por página.</p>
	</div>
</div>